import React, { useState } from "react";
import { DownOutlined, UpOutlined, FileTextOutlined, CheckCircleOutlined, CloseCircleOutlined, SyncOutlined } from "@ant-design/icons";
import { Popconfirm, Tag, Spin, Button } from "antd";
import useAuth from "../../core/hooks/useAuth";
import "./CustomAccordion.scss";

const CustomAccordion = ({
  data,
  handleDownloadFile,
  handleAcceptRequest,
  handleRejectRequest,
  progress,
}) => {
  const [isCardVisible, setIsCardVisible] = useState(false);
  const toggleCard = () => {
    setIsCardVisible(!isCardVisible);
  };

  const { authenticatedUser } = useAuth();

  const { headerLabels, actionButtons, status, additionalInformation } = data;
  const proposedPlanContent = data.content[1];

  const handleCardContentClick = (e) => {
    e.stopPropagation();
  };

  const renderStatusTag = () => {
    switch (status) {
      case "accepted":
        return (
          <Tag icon={<CheckCircleOutlined />} color="success">
            Validated
          </Tag>
        );
      case "pending":
        return <Tag icon={<SyncOutlined />} color="processing">Pending</Tag>;
      case "rejected":
        return (
          <Tag icon={<CloseCircleOutlined />} color="error">
            Rejected
          </Tag>
        );
      default:
        return null;
    }
  };

  let additionalInformationData = [];
  if (additionalInformation?.type !== "inter") {
    additionalInformationData = [
      { key: "Type", content: additionalInformation?.type },
      { key: "Training Mode", content: additionalInformation?.trainingMode },
      {
        key: "Proposed Plan File",
        content: additionalInformation?.type === "intra" ? "No File" : (
          <>
            <FileTextOutlined
              className="file-icon"
              onClick={() => handleDownloadFile(additionalInformation?.proposedPlanFile)}
            />
            {progress > 0 && progress < 100 && <Spin />}
            {progress === 100 && (
              <span className="downloaded_success">Downloaded Successfully</span>
            )}
          </>
        ),
      },
      { key: "Professional Address", content: additionalInformation?.ProfAddress },
      { key: "Job Title", content: additionalInformation?.jobTitle },
      { key: "Country", content: additionalInformation?.country },
      { key: "Location", content: additionalInformation?.location },
      { key: "Phone Number", content: additionalInformation?.phoneNumber },
      { key: "Participants", content: additionalInformation?.participantNumber },
      { key: "Created", content: additionalInformation?.created },
      { key: "Last Modified", content: additionalInformation?.lastModified },
      { key: "Approved By", content: additionalInformation?.approvedBy },
    ];
  } else if (additionalInformation?.type === "inter") {
    additionalInformationData = [
      { key: "Type", content: additionalInformation?.type },
      { key: "Training Mode", content: additionalInformation?.trainingMode },
      { key: "Location", content: additionalInformation?.location },
      { key: "Created", content: additionalInformation?.created },
      { key: "Last Modified", content: additionalInformation?.lastModified },
      { key: "Approved By", content: additionalInformation?.approvedBy },
    ];
  }

  return (
    <div className={`card ${isCardVisible ? "open" : ""}`}>
      <div className="card-header-training" onClick={toggleCard}>
        {headerLabels.map((label, index) => (
          <label
            key={index}
            className={
              (status === "pending" ||
                status === "rejected" ||
                status === "accepted") &&
                (label === "pending" ||
                  label === "rejected" ||
                  label === "accepted")
                ? "label-pending"
                : ""
            }
          >
            {label === "username" && authenticatedUser
              ? authenticatedUser.firstName
              : label}
          </label>
        ))}
        {renderStatusTag()}
        <div className="buttons">
          {actionButtons.includes("Accept") && (
            <Popconfirm
              title="Are you sure you want to Accept this Request?"
              onConfirm={() => status !== "accepted" && handleAcceptRequest(data.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="primary"
                disabled={status === "accepted"}
                className="accept-btn"
              >
                Accept
              </Button>
            </Popconfirm>
          )}
          {actionButtons.includes("Decline") && (
            <Popconfirm
              title="Are you sure you want to Reject this Request?"
              onConfirm={() => status !== "rejected" && handleRejectRequest(data.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="danger"
                disabled={status === "rejected"}
                className="decline-btn"
              >
                Decline
              </Button>
            </Popconfirm>
          )}
          {isCardVisible ? <UpOutlined /> : <DownOutlined />}
        </div>
      </div>

      <div className="card-content" onClick={handleCardContentClick}>
        {isCardVisible && (
          <div className="content-container">
            {additionalInformation?.type !== "inter" && proposedPlanContent && (
              <div className="content-header">
                <h4>Comments</h4>
                <p>{proposedPlanContent}</p>
              </div>
            )}
            <div className="content-informations">
              {additionalInformationData.map((info, index) => (
                <div className="information-container" key={index}>
                  <label className="information-label">{info.key}:</label> {info.content}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomAccordion;
